import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isKioskLockActive } from '../utils/kioskSession';

/** Redirige a /terminal si el modo kiosco está activo y el usuario intenta salir por URL. */
const KioskLockListener = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isKioskLockActive() && location.pathname !== '/terminal') {
      navigate('/terminal', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default KioskLockListener;
